<template>
  <div
    :class="connectionContext ? 'px-4 py-2' : 'p-4'"
    class="border border-truegray-300 rounded flex h-full w-full"
  >
    <div
      class="grid grid-cols-1 gap-4 w-full cursor-pointer"
      :class="connectionContext ? '' : 'lg:grid-cols-12'"
      @click="showModal(report)"
    >
      <div class="col-span-1 lg:col-span-4 flex flex-col justify-center">
        <div
          :class="connectionContext ? 'justify-between items-center' : ''"
          class="flex text-primary capitalize"
        >
          <h6 class="font-bold">{{ yearTagsString }}</h6>
          <div v-if="connectionContext" class="flex items-center">
            <button
              v-if="report?.preferences?.length"
              class="rounded-full border-truegray-300 border py-1 px-2 cursor-default"
            >
              <h6 class="text-truegray-500">
                {{ preferencesTagConfig.firstTag }}
              </h6>
            </button>
            <div
              v-if="preferencesTagConfig?.extraTagsLength > 0"
              :title="preferencesTagConfig?.extraTagsString"
              class="rounded-full cursor-help w-6 h-5 text-xs text-truegray-500 bg-truegray-100 flex items-center justify-center m-0 ml-2 relative transition-all"
            >
              + {{ preferencesTagConfig.extraTagsLength }}
            </div>
          </div>
        </div>
        <h3 class="mb-1 text-base">
          {{ report.report_name }}
        </h3>
        <div class="flex space-x-4 items-center">
          <h6 class="m-0 text-truegray-700">{{ report.engagement_date }}</h6>
          <h6 class="m-0 text-truegray-300">|</h6>
          <h6 v-if="subjectTagConfig" class="m-0 text-truegray-500 flex space-x-2 items-center">
            {{ subjectTagConfig.firstTag }}
            <div
              v-if="subjectTagConfig?.extraTagsLength > 0"
              :title="subjectTagConfig.extraTagsString"
              class="rounded-full cursor-help w-6 h-5 text-xs text-truegray-500 bg-truegray-100 flex items-center justify-center m-0 ml-2 relative transition-all"
            >
              + {{ subjectTagConfig.extraTagsLength }}
            </div>
          </h6>
        </div>
      </div>
      <div
        v-if="!connectionContext"
        class="col-span-1 lg:col-span-3 flex items-center"
      >
        <button
          v-if="report?.preferences?.length"
          class="rounded-full border-truegray-300 border py-1 px-2 cursor-default"
        >
          <h6 class="text-truegray-500">
            {{ preferencesTagConfig.firstTag }}
          </h6>
        </button>
        <div
          v-if="preferencesTagConfig?.extraTagsLength > 0"
          :title="preferencesTagConfig.extraTagsString"
          class="rounded-full cursor-help w-6 h-5 text-xs text-truegray-500 bg-truegray-100 flex items-center justify-center m-0 ml-2 relative transition-all"
        >
          + {{ preferencesTagConfig.extraTagsLength }}
        </div>
      </div>
      <div
        v-if="!connectionContext"
        class="col-span-1 lg:col-span-5 flex items-center justify-between"
      >
        <StackedConnections
          v-if="report?.contacts.length > 1"
          :connections="report.contacts"
          :employment-details="true"
          :hide-company="true"
        />
        <div v-else>
          <ListConnection
            v-for="connection in report.contacts"
            :key="connection.id"
            :connection="connection"
            :width="10"
            :hide-company="true"
          />
        </div>
        <ReportActionMenu :report="report" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
// import { useStore } from '../../../../js/store/index.js'
import { EventBus } from '../../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../../shared/components/loading-dark.json'
import ListConnection from './ListConnection.vue'
import StackedConnections from './StackedConnections.vue'
import ReportActionMenu from './ReportActionMenu.vue'
import { getTagDisplayTitle } from '../../../../js/util/helper.js'

export default defineComponent({
  name: 'CardConnection',
  components: { ListConnection, StackedConnections, ReportActionMenu },

  props: {
    report: {
      type: Object,
      required: true,
    },

    connectionContext: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const loading = ref(false)

    const createTagConfig = (tagsArray) => {
      if (!tagsArray) {return null}
      let firstTag = getTagDisplayTitle(
        tagsArray[0] || {},
        props.report.additional_info,
      )
      const extraTags = tagsArray
        .slice(1)
        .map((tag) => getTagDisplayTitle(tag, props.report.additional_info))

      const extraTagsLength = Math.max(extraTags.length, 0)
      const extraTagsString = extraTags.join(', ')

      return {
        firstTag,
        extraTagsLength,
        extraTagsString,
      }
    }
    const subjectTagConfig = computed(() =>
      createTagConfig(props.report?.subjects),
    )
    const preferencesTagConfig = computed(() =>
      createTagConfig(props.report?.preferences),
    )

    const yearTagsString = computed(() => {
      if (props.report?.years?.length <= 3) {
        return props.report.years.map((tag) => tag.title).join(' | ')
      } else if (props.report?.years?.length) {
        const years = props.report?.years
          .map((tag) => tag.title.replace('Year ', ''))
          .join(', ')
        return `Years: ${years}`
      } 
      return null
    })

    const showModal = (report) => {
      if (props.connectionContext) {
        EventBus.$emit('showConnectionContext', report)
      } else {
        EventBus.$emit('showModal', {
          action: 'report-modal',
          data: report,
        })
      }
    }

    const loadingAnimationOptions = { animationData: loadingAnimation.default }

    return {
      showModal,
      loading,
      loadingAnimationOptions,
      yearTagsString,
      subjectTagConfig,
      preferencesTagConfig,
    }
  },
})
</script>
